import { InputUI, PriceString } from '@fourthwall/components';
import React from 'react';
import * as S from './CurrentMonthSpending.styled';
export const CurrentMonthSpending = ({ value }) => (React.createElement(S.Container, null,
    React.createElement(InputUI.Label, { "$size": "large", "$hasValue": true }, "Charged this month"),
    React.createElement(S.Content, null,
        React.createElement(PriceString, { ...value }))));
